export const COMMENT_INDICATOR_IDENTIFIER = 'comment-indicator';
export const COMMENTABLE_AREA_IDENTIFIER = 'commentable-area';